const meta_data = {
    "meta.title.home": "1-DAY ACUVUE® DEFINE®",
    "meta.desc.home": "Lensa kontak harian yang memadukan seni, sains, dan teknologi, dirancang khusus untuk kenyamanan, kecantikan, dan kesehatan paripurna.",
    "meta.title.vm": "Coba Lensa Kontak ACUVUE® DEFINE® Secara Virtual",
    "meta.desc.vm": "Temukan lensa kontak 1-DAY ACUVUE® DEFINE® yang sempurna untuk matamu",
    "meta.title.discover": "Jelajahi katalog ACUVUE® DEFINE®",
    "meta.desc.discover": "Kreasikan cantikmu dengan pilihan corak bernuansa alami dan warna-warni yang terinspirasi dari alam.",
    "meta.title.classic": "Jelajahi ACUVUE® DEFINE® Classic",
    "meta.desc.classic": "1-DAY ACUVUE® DEFINE® lensa kontak dengan warna bernuansa alami yang menjernihkan dan menegaskan mata.",
    "meta.title.fresh": "Jelajahi ACUVUE® DEFINE® Fresh",
    "meta.desc.fresh": "1-DAY ACUVUE® DEFINE® FRESH lensa kontak dengan warna bernuansa alami mencerahkan untuk kreasikan kecantikanmu. ",
}

export default meta_data;